/*
         * @ngdoc function
         * @name ePay.Model:Session_AppleRequestModel
         * @description
         * Model
         */

export class Session_AppleRequestModel {
  navigateUrl: string | null | undefined;

	constructor(
		navigateUrl?: string
	) {
		this.navigateUrl = navigateUrl || null;
	}
}
